import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { routes } from '../../routes';
import { createClassRoomType } from '../../services/school/classroom/classroom';
import { ClassroomTypesType } from '../../types/Classroom';
import { CreateClassroomTypeFormValidation } from './CreateClassroomTypeFormValidation';
export const CreateClassroomType = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createClassRoomType, mutationKey: 'createClassRoomType' });
  const { control, handleSubmit, formState: { errors } } = useForm<ClassroomTypesType>
    (
      {
        resolver: yupResolver(CreateClassroomTypeFormValidation),
        defaultValues: {
          description: ''
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Tipo de sala criada!");
        navigate(routes.classroomTypes);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.classroomTypes);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label="Tipo de sala" control={control} errors={errors} fieldProps={{ placeholder: 'Tipo de sala' }} required={true}/>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}